import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './dashboard.css';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Sidebar from './components/Sidebar';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Tasks from './components/Tasks';
import Shopping from './components/Shopping';
import Thoughts from './components/Thoughts';
import Activities from './components/Activities';
import Workouts from './components/Workouts';
import Golf from './components/Golf';
import GolfTips from './components/GolfTips';
import Health from './components/Health';
import ClassesLayout from './components/classes/ClassesLayout';
import ClassesIndex from './components/classes/ClassesIndex';
import ClassTdaMl from './components/classes/ClassTdaMl';
import ClassPythonMl from './components/classes/ClassPythonMl';
import Transactions from './components/Transactions';

function AppLayout() {
  return (
    <div className="app-shell">
      <Sidebar />
      <main className="app-main">
        <Routes>
          <Route path="/"           element={<Dashboard />} />
          <Route path="/tasks"      element={<Tasks />} />
          <Route path="/shopping"   element={<Shopping />} />
          <Route path="/thoughts"   element={<Thoughts />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/workouts"   element={<Workouts />} />
          <Route path="/golf"       element={<Golf />} />
          <Route path="/golf-tips"  element={<GolfTips />} />
          <Route path="/health"        element={<Health />} />
          <Route path="/transactions"  element={<Transactions />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/golf-tips" element={<GolfTips />} />
          <Route path="/classes" element={<ClassesLayout />}>
            <Route index element={<ClassesIndex />} />
            <Route path="tda-ml" element={<ClassTdaMl />} />
            <Route path="python-ml" element={<ClassPythonMl />} />
          </Route>
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
